import React from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import { FormControl } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';
import * as yup from 'yup';

import LoginContainer from './LoginContainer';
import { ControlledInput } from '../../components/forms';
import ControlledCheckbox from '../../components/forms/ControlledCheckbox';
import { StyledLoadingButton } from '../../components/forms/LoadingButton';

const FormFields = styled.div`
    margin-bottom: 0.5rem;
`;

const StyledFormControl = styled(FormControl)`
    margin-bottom: 0.5rem;
`;

const FormContainer = styled.div`
    display: flex;
    align-items: center;
`;

const RememberMe = styled.div`
    display: flex;
    align-items: center;
`;

const ForgotPassword = styled.div`
    margin-left: auto;

    a {
        border-bottom: 1px solid ${(props) => props.theme.colors.primary.main};
    }
`;

const AdditionalFormActions = styled.div`
    display: flex;
    align-items: center;
    font-size: 14px;
`;

const SignInButton = styled(StyledLoadingButton)`
    padding: 8px 12px;
    font-size: 16px;
`;

export interface LoginFormProps {}

const EmailPasswordForm: React.FC<LoginFormProps> = () => {
    const { login, isAuthenticating, isOriginMeeting } = useContainer(LoginContainer);

    const { t } = useTranslation('login');

    const schema = yup.object({
        email: yup.string().email(t('errors.invalid-email')).required(t('errors.invalid-email')),
        password: yup.string().required(t('errors.invalid-password'))
    });

    const { control, handleSubmit } = useForm({ resolver: yupResolver(schema) });

    const onSubmit = async (data) => {
        login(data);
    };

    return (
        <FormContainer>
            <form onSubmit={handleSubmit(onSubmit)}>
                <FormFields>
                    <StyledFormControl fullWidth>
                        <ControlledInput type="email" name="email" label={t('email')} control={control} autoFocus />
                    </StyledFormControl>
                    <StyledFormControl fullWidth>
                        <ControlledInput type="password" name="password" label={t('password')} control={control} />
                    </StyledFormControl>
                </FormFields>
                <SignInButton fullWidth variant={'contained'} type={'submit'} loading={isAuthenticating}>
                    {isOriginMeeting ? t('sign-in-and-join-your-class') : t('sign-in')}
                </SignInButton>
                <AdditionalFormActions>
                    <RememberMe>
                        <ControlledCheckbox
                            name="rememberMe"
                            disableRipple
                            control={control}
                            label={t('remember-me')}
                        />
                    </RememberMe>
                    <ForgotPassword>
                        <span>
                            <Link to={'/password-reset'}>{t('forgot-password')}</Link>
                        </span>
                    </ForgotPassword>
                </AdditionalFormActions>
            </form>
        </FormContainer>
    );
};

export default EmailPasswordForm;
